import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {DATA_IMPORT_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'

export const DATA_IMPORT = 'dataimport'

export default function DataImportLocationListener() {
  const {
    pathComponents: [resource],
  } = useSelector(locationSelector)
  const isThisPage = resource === DATA_IMPORT

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(DATA_IMPORT_PAGE))
  }, [isThisPage])

  return null
}
